import DialogBody from './DialogBody';
import DialogFooter from './DialogFooter';
import Dialog from './Dialog';

Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;

export default Dialog;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/dialog/index.js
// module id = 377
// module chunks = 0